<template>
  <o-collapsed-autocomplete
      v-model="model"
      v-on="forwardListeners"
      :dense="dense"
      :disabled="disabled"
      :error-messages="errorMessage"
      :hide-details="hideDetails"
      :items="countries"
      :label="label"
      :loading="countries.length === 0"
      :outlined="outlined"
      :required="required"
      :return-object="returnObject"
      :multiple="multiple"
      :chips="chips"
      :selection-text="selectionText"
      :search-input.sync="searchInput"
      :clearable="clearable"
      @change="searchInput=''"
      :item-text="itemText"
      item-value="iso_3_code"
      menu-props="auto"
  />
</template>

<script>
import OCollapsedAutocomplete from './inputs/OCollapsedAutocomplete.vue'
import { formatCountryLabel } from '@/helpers/countries'

export default {
  name: 'CountriesAutocomplete',
  components: { OCollapsedAutocomplete },
  data () {
    return {
      countries: [],
      searchInput: ''
    }
  },
  props: {
    errorMessage: {
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Object, Array],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    itemText: {
      type: [String, Function],
      // Vue calls the default of a [String, Function] prop as a factory, so it must return the formatter.
      // Vuetify calls item-text as (item, fallback): only the country is forwarded, so the code key keeps its default.
      default: () => (country) => formatCountryLabel(country)
    },
    selectionText: {
      type: [String, Function],
      default: null
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default () {
        return this.$t('components.countriesAutocomplete.country')
      }
    }
  },
  watch: {
    '$i18n.locale' (locale) {
      this.countries = this.$loadCountries(locale)
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    forwardListeners () {
      return Object.fromEntries(
        Object.entries(this.$listeners).filter(([key]) => key !== 'input')
      )
    }
  },
  mounted () {
    this.countries = this.$loadCountries(this.$i18n.locale)
  }
}
</script>
